<template>
  <div class="sv-codeeditor-container">
    <!-- eslint-disable -->
    <div ref="monacoEditorCode" class="sv-monaco-editor" id="monaco-editor"></div>
  </div>
</template>

<script>
import * as monaco from "monaco-editor/esm/vs/editor/editor.api.js";

export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    tag: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editorCode: null
    };
  },

  computed: {},

  watch: {
    value(value) {
      // изменения прилетели извне редактора HTML?
      const changedOutsideHTML =
        this.editorCode && this.editorCode.getValue() !== value;
      // valueFixed изменилось извне редактора HTML, следовательно надо обновить его в редакторе
      changedOutsideHTML && this.editorCode.setValue(value);
    }
  },

  mounted() {
    //Create code editor
    const editorCodeOptions = {
      language: "html",
      theme: "vs",
      automaticLayout: true,
      minimap: { enabled: false }
    };

    this.editorCode = monaco.editor.create(
      this.$refs.monacoEditorCode,
      editorCodeOptions
    );

    // привязываем вызов обновления при изменении контента в редакторе значения (печатании)
    this.editorCode.onDidChangeModelContent(() => {
      const value = this.editorCode.getValue();
      this.$emit("input", value);
    });
  },

  beforeDestroy() {
    this.editorCode?.dispose();
  },

  methods: {}
};
</script>
<style lang="scss" scoped>
@import "@/styles/branding.scss";
.sv-codeeditor-container {
  border: 1px solid $brand-control-border;
}
</style>
